<form [formGroup]="form" class="family-goals-step">
  <app-textarea
    [control]="form.controls.familyGoals"
    [label]="familyGoalsLabel"
    [required]="false"
  />
</form>
